import React from 'react';
import {Link} from 'gatsby';
import {useCategories} from '../../query/useCategories';
import ListProduct from '../../components/ListProduct';

import styles from './styles.module.css';

const CategoriesProducts = ({limit}) => {
  const {categories} = useCategories();
  return (
    <div className={styles.categories_products}>
      {categories.edges.map(({node}) => {
        const {productsCategorie} = node;
        // display only if has product
        if (productsCategorie === null || productsCategorie.length === 0) {
          return null;
        }

        const {slug} = node.fields;
        const {title} = node.frontmatter;
        return (
          <div key={slug} className={styles.categorie}>
            <div className={styles.header}>
              <h2>
                <Link to={slug}>{title}</Link>
                <Link to={slug}>Voir tous les {title}</Link>
              </h2>
            </div>
            <div className={styles.products}>
              {productsCategorie.slice(0, limit).map(p => (
                <ListProduct key={p.id} product={p} />
              ))}
            </div>
            <div className={styles.footer}>
              <Link to={slug}>Voir tous les {title}</Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

CategoriesProducts.defaultProps = {
  limit: 6,
};

export default CategoriesProducts;
